module.exports = __webpack_public_path__ + "static/media/img_location_ny.0d80743e.jpg";